import { componentMap } from "./utility/componentMap";
import React, { useEffect, useState, useRef, Suspense } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Loader from "./components/FormsUI/Loader/index";
import { GetRoles } from "./utility/getRoles";
import { RequireAuth } from "./utility/RequireAuth";
import { AuthProvider } from "./utility/auth";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { useMode } from "./theme";
import Login from "./pages/login.jsx";
import isTokenExpired from "./utility/isTokenExpired";
// import useOnlineStatus from "./utility/useOnlineStatus";
const SidebarLayout = React.lazy(() =>
  import("./components/global/SidebarLayout")
);
const Bank = React.lazy(() => import("./pages/Bank"));
const PosterSendOnWhatsApp = React.lazy(() => import("./pages/PosterSendOnWhatsapp"));
const WhatsAppGroup = React.lazy(() => import("./pages/WhatsAppGroup"));
const InternetStatusBanner = React.lazy(() => import("./pages/InternetConnection"))
const ConnectWhatsapp = React.lazy(() => import("./pages/ConnectWhatsapp"));
const Profile = React.lazy(() => import("./pages/InternetProfile"));
const Notfound = React.lazy(() => import("./pages/notFound"));
const ContentManage = React.lazy(() => import("./pages/Manage/contentManage"));
const Reports = React.lazy(() => import("./pages/reports"));
const ChangePassword = React.lazy(() => import("./pages/changePassword"));
const Address = React.lazy(() => import("./pages/AddressDetails"));
const FeeReceipt = React.lazy(() => import("./pages/feeReceipt"));
// const CreateUser = React.lazy(() => import("./pages/CreateUser"));
const CreateTenant = React.lazy(() =>
  import("./pages/SuperAdmin/CreateTenants")
);
const Encryption = React.lazy(() => import("./pages/SuperAdmin/encryption"));
const Membership = React.lazy(() => import("./pages/memberShip"));
const Donation = React.lazy(() => import("./pages/DonationComponent"));

function App() {
  // debugger
  const [accessRoutes, setAccessRoutes] = useState(null);
  const [theme] = useMode();
  const [role, setRole] = useState("");
  const [isInactive, setIsInactive] = useState(false);
  const navigate = useNavigate();
  const inactivityTimer = useRef(null);

  // Load routes from sessionStorage
  useEffect(() => {
    const stored = sessionStorage.getItem("accessRole");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        const flatRoutes = parsed.flatMap((menuGroup) =>
          menuGroup.subMenus.map((sub) => ({
            path: sub.path,
            componentName: sub.component,
          }))
        );
        setAccessRoutes(flatRoutes);
      } catch (error) {
        console.error("Error parsing accessRole:", error);
        setAccessRoutes([]); // fallback
      }
    } else {
      setAccessRoutes([]); // no role → no routes
    }
  }, []);

  // Inactivity timer setup
  useEffect(() => {
    const handleClick = (event) => {
      if (
        window.location.pathname === "/login" ||
        event.target.name === undefined
      ) {
        return;
      }
      isTokenExpired(navigate);
    };

    const resetInactivityTimer = () => {
      setIsInactive(false);
      if (inactivityTimer.current) {
        clearTimeout(inactivityTimer.current);
      }

      inactivityTimer.current = setTimeout(() => {
        setIsInactive(true);
      }, 10 * 60 * 1000); // 10 Minutes set JWT to 2 hours ask Murtaza Sir
    };

    const handleUserActivity = () => {
      resetInactivityTimer();
    };

    const events = ["click", "mousemove", "keypress", "scroll", "touchstart"];
    events.forEach((event) => {
      window.addEventListener(event, handleUserActivity);
    });

    // Attach the click event listener to the document or window
    document.addEventListener("click", handleClick);

    // Set the initial inactivity timer
    resetInactivityTimer();

    // Clean up the event listeners when the component unmounts
    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, handleUserActivity);
      });
      document.removeEventListener("click", handleClick);
      if (inactivityTimer.current) {
        clearTimeout(inactivityTimer.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isInactive) {
      sessionStorage.removeItem("LastLogin");
      sessionStorage.removeItem("TenantName");
      sessionStorage.removeItem("accessRole");
      sessionStorage.removeItem("user");
      navigate("/login", { state: { data: "expired" } });
    }
  }, [isInactive, navigate]);

  // Prevent premature rendering
  if (accessRoutes === null) {
    return <Loader />; // Show loader until routes are ready
  }

  return (
    <AuthProvider>
      <GetRoles setRole={setRole} />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <InternetStatusBanner />
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route element={<SidebarLayout />}>
              {accessRoutes.map(({ path, componentName }) => {
                const Component = componentMap[componentName];
                return (
                  Component && (
                    <Route
                      key={path}
                      path={path}
                      element={
                        <RequireAuth>
                          <Component />
                        </RequireAuth>
                      }
                    />
                  )
                );
              })}
            </Route>
            <Route
              path="/"
              element={<Login setRole={setRole} setAccessRoutes={setAccessRoutes} />}
            />
            <Route
              path="/login"
              element={<Login setRole={setRole} setAccessRoutes={setAccessRoutes} />}
            />
            <Route path="*" element={<Notfound />} />
          </Routes>
        </Suspense>
      </ThemeProvider>
    </AuthProvider>
  );
}



export default App;
